import {Component, Input, OnInit} from '@angular/core';
import {CommonService} from "../../common/common.service";
import {saveAs} from "file-saver";
import {NotificationType} from "../notifier/notification-type.enum";
import {NotifierService} from "../notifier/notifier.service";
import {JoyrideService} from "ngx-joyride";
import {UserReportsService} from "../user-reports/user-reports.service";

@Component({
  selector: 'pbc-start-tour',
  templateUrl: './start-tour.component.html',
  // styleUrls: ['./start-tour.component.scss']
})
export class StartTourComponent implements OnInit {

  @Input() show = true;

  constructor(
    private commonService : CommonService,
    private notifierService : NotifierService,
    private joyrideService : JoyrideService,
    private userReportsService : UserReportsService
  ) { }

  closeTourPopup()  {
    this.show = false
  }

  getInstruction() {
    this.commonService.getInstruction().subscribe(
      data=> {
        saveAs(data, 'instrukcja użytkownika.pdf');
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać instrukcji użytkownika")
      }
    )
  }

  startTour(){
    this.closeTourPopup();
    const options = {
      steps: [
        'top-menu@user-reports/0',
        'reportDetails@user-reports/0',
        'getReport@user-reports/0',
        'shareAndSave@user-reports/0',
        'filtruj@user-reports/0',
        'searchBox@user-reports/0',
        'help@user-reports/0',
        'contact@user-reports/0'
      ],
      stepDefaultPosition: 'bottom',
      themeColor: '#303030',
      showPrevButton: true,
      logsEnabled: false
    };
    this.joyrideService.startTour( options).subscribe(
      (step) => {
        this.userReportsService.setSelfTutorInProgress(true);
      },
      (error) => {
        console.log(error);
        this.userReportsService.setRefresh(false);
        this.userReportsService.setSelfTutorInProgress(false);
      },
      () => {
        this.userReportsService.setRefresh(false);
        this.userReportsService.setSelfTutorInProgress(false);
      }
    );
  }

  ngOnInit() {
  }

}
